import Model from "@/models/Model";

export default class JournalEntry extends Model {
    resource() {
        return "entries";
    }

    baseURL() {
        return super.baseURL() + "/journal";
    }

    like(liked) {
        if (liked) {
            return this.$http.post(
                this.endpoint() + "/likes"
            );
        } else {
            return this.$http.delete(
                this.endpoint() + "/likes"
            );
        }
    }

    toPayload(){
        let payload = {
            id: this.id,
            title: this.title,
            body: this.body,
            user_id: this.user_id,
            user_type: this.user_type,
            whole_class: this.whole_class,
            approved_by: this.approved_by,
            attachments: this.related.attachments.map(attachment => {
                let attachmentObj = {
                    order_id: attachment.order,
                    type: "type"
                };

                // only keep url if no file id is not present, the backend only allows one
                if (attachment.file_id) {
                    attachmentObj["file_id"] = attachment.file_id;
                    attachmentObj["version"] = attachment.version;
                }else{
                    attachmentObj["url"] = attachment.url;
                }

                return attachmentObj;
            }),
            users: [],
            tags: [],
            progressions: [],
        };

        if (this?.related?.tags?.length) {
            this?.related?.tags.forEach((tag) => {
                payload.tags.push({id: tag.id});
            });
        }

        if (this?.related?.users?.length) {
            this?.related?.users.forEach((user) => {
                payload.users.push({user_id: user.id});
            });
        }

        if (this?.related?.progressions?.length) {
            this?.related?.progressions.forEach((p) => {
                payload.progressions.push({user_id: p.user_id, level:p.level, statement_id: p.statement_id});
            });
        }


        return payload;
    }
}
